/**
 * 策划中心公用指令
 * 
 */
angular.module("planningCenterDirModule", [
    "topNewsPaperColumnarDirModule"
]);